import dayjs from 'dayjs';
import { getTimeInFeed, formatNum } from '@/utils';

import { FeedArticle } from '../types';
import { transAuthor, getShowVip } from './detail';

export const formatStreamValue = (num?: number) => {
  if (!num && num !== 0) {
    return '';
  }
  if (num < 100) {
    return formatNum(num, 2);
  }

  if (num < 1000) {
    return formatNum(num, 0);
  }

  return formatNum(num, 1, {
    abbrStart: 1,
  });
};

const formatDraw = (draw?: FeedArticle['draw']) => {
  if (!draw) {
    return;
  }

  draw._prize_count = formatNum(draw.prize_count, 2, { abbrStart: 3 });
};

export const transArticle = (article: FeedArticle) => {
  article._isBot = article.type === 'monitor_alert';
  article._daytime = getTimeInFeed(article.create_at);
  article._fulltime = dayjs.unix(article.create_at).format('hh:mm A · MMM DD YYYY');

  if (article._isBot) {
    article._botName = article.monitor_alert?.bot?.is_active
      ? article.monitor_alert?.bot?.name || ''
      : 'offline bot';
  }

  article._author = transAuthor({ user: article.creator });
  // 如果是 bot 的话，就不在 stream 的作者旁展示 vip 了
  article._showVip = getShowVip(article.creator) && !article._isBot;
  article._realizedValue = formatStreamValue(article.realized_value);
  article._commentCount = formatStreamValue(article.comment_count);
  article._repostCount = formatStreamValue(
    (article.repost_count || 0) + (article.quote_count || 0),
  );
  article._readCount = formatStreamValue(article.read_count);
  article._trustCount = formatStreamValue(article.trust_count);
  article._distrustCount = formatStreamValue(article.distrust_count);
  article._bookmarkCount = formatStreamValue(article.bookmark_count || 0);
  article.trust_degree = article.trust_degree > 1 ? Math.round(article.trust_degree) : 1;
  article._rewardUsdValue = `$${
    article.reward_usd_value
      ? formatNum(article.reward_usd_value, article.reward_usd_value < 1 ? 2 : 0, {
          abbrStart: 1,
        })
      : 0
  }`;

  // 本地更新时间，用来判断是否要单独更新它
  article.updateAt = +new Date();

  formatDraw(article.draw);

  if (article.poll?.vote_stats && article.poll.vote_count) {
    article.poll._voteStats = Object.entries(article.poll.vote_stats).reduce(
      (m, [k, v]) => {
        const percent = (v / article.poll!.vote_count) * 100;

        m![Number(k)] = {
          percent,
          formatedPercent: `${formatNum(percent, 0)}%`,
          count: v,
        };

        return m;
      },
      {} as Required<FeedArticle>['poll']['_voteStats'],
    );
  }

  if (article.type === 'pay_thread') {
    article._price = `$${formatNum((article.price || 0) / 10000)}`;
    article._payCount = formatNum(article.pay_count);
    article.thread_count = article.thread_count ?? 0;
  }

  if (article.type === 'pay_qa' && article.pay_qa) {
    article.pay_qa._price = `$${formatNum(article.pay_qa.price / 10000)}`;
    article.pay_qa._offerPrice = `$${formatNum(article.pay_qa.offer_price / 10000)}`;
    article.pay_qa._payCount = article.pay_qa?.pay_count
      ? formatNum(article.pay_qa?.pay_count)
      : '0';
    const endAt = dayjs.unix(article.pay_qa.expire_at);
    article.pay_qa._endAt = endAt.format('MM/DD HH:mm');
    article.pay_qa._isExpired = !article.thread_count && endAt.isBefore(+new Date());
  }

  if (article.quest) {
    formatDraw(article.quest.draw);
    article.quest._xp = formatNum(article.quest.unit_xp);
    article.quest._joinCount = formatNum(article.quest.join_count);
    article.quest._estimatedJoinCount = formatNum(article.quest.estimated_join_count);
    article.quest._claimedXp =
      article.quest.actions?.reduce((prv, cur) => {
        const claimedActionXp = cur?.is_verified ? cur?.unit_xp : 0;
        return prv + claimedActionXp;
      }, 0) || 0;

    article.quest.actions?.forEach(x => {
      if (x.type === 'token_holder') {
        x.data.action_url = `https://debank.com/token/${x.data.chain_id}/${x.data.token_id}`;
      } else if (x.type === 'nft_holder') {
        x.data.action_url = `https://debank.com/nfts/${x.data.chain_id}/${x.data.collection_id}`;
      }
    });
  }

  if (article.quote_article) {
    transArticle(article.quote_article);
  }

  return article;
};
